import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import "./view-quotation.css";
import QuotationDetails from "./quotation-details";
import { getQuatationById, updateQuatationById, geographicalCountry, fetchCityList, fetchState } from "../../api";
import { useParams } from "react-router-dom";
import { Decrypt } from "../../services/data-encription";

// Helper component for Accordion sections
const Accordion = ({ title, children, isOpen, toggleAccordion }) => (
  <div className="accordion-section">
    <button className="accordion-header" onClick={toggleAccordion}>
      {title}
      <span className={`accordion-icon ${isOpen ? "open" : ""}`}>&#9660;</span>
    </button>
    {isOpen && <div className="accordion-content">{children}</div>}
  </div>
);

const visibleFields = [
  "assistanceScheme", "documentType", "geoScope", "country", "jsd", "jed", "tnod",
  "proposerPassport", "proposerUniqueNumber", "proposerDob", "proposerGender", "proposerTitle", "proposerFname", "proposerMname", "proposerLname",
  "travellerPassport", "travellerUniqueNumber", "travellerDob", "travellerGender", "travellerTitle", "travellerFname", "travellerMname", "travellerLname",
  "travellerCi", "travellerPed", "planChange", "cover",
  "nomineeRelationship", "nomineeDob", "nomineeTitle", "nomineeFname", "nomineeMname", "nomineeLname",
  "proposerPincode", "countryOfResidence", "state", "city", "address",
  "proposerEmail", "proposerMobile", "gstCheckbox", "gstEmail", "gstMob", "gst", "companyName", "companyAddress"
];

const freezedFields = [
  "assistanceScheme", "documentType", "geoScope", "proposerPassport", "proposerUniqueNumber", "travellerPassport", "travellerUniqueNumber",
  "travellerCi", "travellerPed", "planChange", "cover",
  // PED related readonly traveller fields
  "ped_type", "suffering_since", "critical_illness", "under_medication",
  "countryOfResidence", "state", "city",
  "gstCheckbox", "gstEmail", "gstMob", "gst", "companyName", "companyAddress"
];

const dateFields = [
  "jsd", "jed", "proposerDob", "travellerDob"
];

const FIELDS = [
  // Travel Details
  { key: "assistanceScheme", label: "Assistance Scheme", variant: "light", section: "Travel Details" },
  { key: "documentType", label: "Type of Document", variant: "light", section: "Travel Details" },
  { key: "geoScope", label: "GEO Scope", variant: "normal", section: "Travel Details" },
  { key: "country", label: "Country", variant: "normal", section: "Travel Details" },
  { key: "jsd", label: "Journey Start Date", variant: "normal", section: "Travel Details" },
  { key: "jed", label: "Journey End Date", variant: "normal", section: "Travel Details" },
  { key: "tnod", label: "Total No Of Travel Days", variant: "light", section: "Travel Details" },
  { key: "planChange", label: "Plan", variant: "light", section: "Travel Details" },
  { key: "cover", label: "Cover", variant: "normal", section: "Travel Details" },

  // Proposer Details
  { key: "proposerPassport", label: "Proposer Passport", variant: "light", section: "Proposer Details" },
  { key: "proposerUniqueNumber", label: "Proposer Unique Number", variant: "light", section: "Proposer Details" },
  { key: "proposerDob", label: "Proposer DOB", variant: "normal", section: "Proposer Details" },
  { key: "proposerGender", label: "Proposer Gender", variant: "normal", section: "Proposer Details" },
  { key: "proposerTitle", label: "Proposer Title", variant: "normal", section: "Proposer Details" },
  { key: "proposerFname", label: "First Name", variant: "normal", section: "Proposer Details" },
  { key: "proposerMname", label: "Middle Name", variant: "normal", section: "Proposer Details" },
  { key: "proposerLname", label: "Last Name", variant: "normal", section: "Proposer Details" },

  // Traveller Details
  { key: "travellerPassport", label: "Traveller Passport No.", variant: "light", section: "Traveller Details" },
  { key: "travellerUniqueNumber", label: "Traveller Unique Number", variant: "light", section: "Traveller Details" },
  { key: "travellerDob", label: "Traveller DOB", variant: "normal", section: "Traveller Details" },
  { key: "travellerGender", label: "Traveller Gender", variant: "normal", section: "Traveller Details" },
  { key: "travellerTitle", label: "Traveller Title", variant: "normal", section: "Traveller Details" },
  { key: "travellerFname", label: "First Name", variant: "normal", section: "Traveller Details" },
  { key: "travellerMname", label: "Middle Name", variant: "normal", section: "Traveller Details" },
  { key: "travellerLname", label: "Last Name", variant: "normal", section: "Traveller Details" },
  { key: "travellerCi", label: " Critical Illness", variant: "light", section: "Traveller Details" },
  { key: "travellerPed", label: "Traveller PED", variant: "light", section: "Traveller Details" },

  // Nominee Details
  { key: "nomineeRelationship", label: "Nominee Relationship", variant: "normal", section: "Nominee Details" },
  { key: "nomineeDob", label: "Nominee DOB", variant: "normal", section: "Nominee Details" },
  { key: "nomineeTitle", label: "Nominee Title", variant: "normal", section: "Nominee Details" },
  { key: "nomineeFname", label: "First Name", variant: "normal", section: "Nominee Details" },
  { key: "nomineeMname", label: "Middle Name", variant: "normal", section: "Nominee Details" },
  { key: "nomineeLname", label: "Last Name", variant: "normal", section: "Nominee Details" },
];

const REQUIRED_EDITABLE = ["country", "jsd", "jed", "proposerDob", "travellerDob", "proposerEmail", "proposerMobile"];

const ViewQuotation = ({ isStepper, onNext, setQuotationValid, setUserId, onQuoteData, onLoadError }) => {
  const params = useParams();
  const encryptedData = params.id;
//   const id = params.id;
  

    let decryptedData = null;
    try {
    decryptedData = Decrypt(decodeURIComponent(encryptedData));
    // If your Decrypt returns a JSON string, use JSON.parse, otherwise just use the result.
    } catch (e) {
    console.error("Failed to decrypt quotation data", e);
    }
    //   const decryptedData = JSON.parse(decodeURIComponent(encryptedData));
  console.log("Decrypted Data:", decryptedData);  
  const id = decryptedData?.quotation_number
  // Set userId from decryptedData if available
  React.useEffect(() => {
    if (setUserId && decryptedData?.user_id) {
      setUserId(decryptedData.user_id);
    }
  }, [setUserId, decryptedData]);
  const initial = FIELDS.reduce((acc, f) => ({ ...acc, [f.key]: "" }), {});
  const [values, setValues] = useState({
    ...initial,
    assistanceScheme: "Travel Care",
    documentType: "Passport",
    geoScope: "Worldwide",
    country: [],
    proposerFname: "",
    proposerLname: "",
  proposerUniqueNumber: "",
    travellerFname: "",
    travellerLname: "",
  travellerUniqueNumber: "",
    proposerEmail: "",
    proposerMobile: "",
    nomineeFname: "",
    nomineeLname: "",
    nomineeRelationship: "",
    proposerPincode: "",
    countryOfResidence: "",
    state: "",
    city: "",
    address: "",
    jsd: "",
    jed: "",
    tnod: "",
    travellerPed: "",
    ped_type: "",
    suffering_since: "",
    critical_illness: "",
    under_medication: ""
  });
  // AMT (Annual Multi Trip) detection flag
  const [isAMT, setIsAMT] = useState(false);
  // A2A (Anywhere to Anywhere) detection flag & country pair selections
  const [isA2A, setIsA2A] = useState(false);
  // Domestic detection flag (geo scope name === 'Domestic')
  const [isDomestic, setIsDomestic] = useState(false);
  // Store domestic specific raw values (cities/states/premiums) to append in payload without exposing new editable fields yet
  const domesticRef = useRef(null);
  const [fromCountry, setFromCountry] = useState([]); // single-select stored as 0/1 length array
  const [toCountry, setToCountry] = useState([]);
  // Error state for validation
  const [errors, setErrors] = useState({ tnod: "", nomineeRelationship: "" });
  // General interaction ref to indicate user attempted to proceed
  const interactedAnyRef = useRef(false);
  // store planId discovered from API fetch so it can be included in update payloads
  const planIdRef = useRef(null);

  // Common portal props for react-select to avoid clipping inside accordions
  const selectPortalProps = React.useMemo(() => ({
    menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
    styles: {
      menuPortal: base => ({ ...base, zIndex: 9999 })
    }
  }), []);

  // Helper to calculate travel days
  const calculateTravelDays = (start, end) => {
    if (!start || !end) return "";
    const startDate = new Date(start);
    const endDate = new Date(end);
    if (isNaN(startDate) || isNaN(endDate)) return "";
    const diff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (diff < 0) return "";
    // Inclusive counting: same day = 1, next day = 2, etc.
    return diff + 1;
  };

  // AMT helper: end date = start + 364 (365 days total)
  const calcAmtEndDate = (start) => {
    if (!start) return "";
    const d = new Date(start);
    if (isNaN(d)) return "";
    d.setDate(d.getDate() + 364);
    return d.toISOString().split("T")[0];
  };

  // Handlers for date changes
  const handleJsdChange = (e) => {
    const newStart = e.target.value;
    setValues((prev) => {
      if (isAMT) {
        const autoEnd = calcAmtEndDate(newStart);
        return { ...prev, jsd: newStart, jed: autoEnd, tnod: autoEnd ? 365 : "" };
      }
      const tnod = calculateTravelDays(newStart, prev.jed);
      return { ...prev, jsd: newStart, tnod };
    });
  };

  const handleJedChange = (e) => {
    if (isAMT) return; // ignore manual edits for AMT
    const newEnd = e.target.value;
    setValues((prev) => {
      const tnod = calculateTravelDays(prev.jsd, newEnd);
      return { ...prev, jed: newEnd, tnod };
    });
  };

  const handleTnodChange = (e) => {
    if (isAMT) return; // fixed 365 for AMT
    const newTnod = e.target.value;
    let newJed = values.jsd;
    if (values.jsd && newTnod) {
      const startDate = new Date(values.jsd);
      // Inclusive end date: for tnod=N, end date = start + (N - 1) days
      startDate.setDate(startDate.getDate() + Number(newTnod) - 1);
      newJed = startDate.toISOString().split("T")[0];
    }
    setValues((prev) => ({ ...prev, tnod: newTnod, jed: newJed }));
    // Validation for tnod
    setErrors((prev) => ({
      ...prev,
      tnod: !newTnod || Number(newTnod) < 1 ? "Travel days must be at least 1." : ""
    }));
  };

  const [loading, setLoading] = useState(false);
  // Guard to prevent multiple rapid submissions / repeated error toasts
  const [submitting, setSubmitting] = useState(false);
  const [countryOptions, setCountryOptions] = useState([]);
  // Domestic routing select data
  const [stateOptions, setStateOptions] = useState([]);
  const [fromStateSel, setFromStateSel] = useState(null);
  const [toStateSel, setToStateSel] = useState(null);
  const [fromCityOptions, setFromCityOptions] = useState([]);
  const [toCityOptions, setToCityOptions] = useState([]);
  const [fromCitySel, setFromCitySel] = useState(null);
  const [toCitySel, setToCitySel] = useState(null);
  // Throttle control to avoid rapid re-submission loops after an error
  const [lastSubmitAt, setLastSubmitAt] = useState(0);

  // Fetch quotation and country list
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await getQuatationById(id);
        const data = response?.data?.result?.dataValues?.document_data;
        const rawData = response?.data?.result;
        // If the API returned no usable quotation data, treat it as a load error so
        // the parent stepper can show the 'link expired' / error UI instead of
        // leaving the form populated with initial dummy values.
        if (!rawData || !data) {
          console.warn('fetchData: missing quotation data', { response });
          throw new Error('No quotation data returned from API');
        }
        // Build country list and selected countries (restored logic)
        let geoCountryIds = [];
        const geoCoverId = data?.geographical_cover_id || data?.geographical_cover_id;
        let countryList = [];
        if (geoCoverId) {
          try {
            const countryRes = await geographicalCountry(geoCoverId);
            countryList = countryRes?.data?.result?.map((country) => ({
              value: country?.Country?.country_id,
              label: country?.Country?.name,
            })) || [];
            setCountryOptions(countryList);
          } catch (cErr) {
            console.warn('Failed to fetch country list', cErr);
          }
        }
        geoCountryIds = Array.isArray(data?.documentDetails?.geo_country)
          ? data?.documentDetails?.geo_country
          : data?.documentDetails?.geo_country
          ? [data?.documentDetails?.geo_country]
          : [];
        const selectedCountries = geoCountryIds
          .map((code) => countryList.find((opt) => opt.value === code))
          .filter(Boolean);

        // Normalization helpers for gender/title
        const normalizeGender = (g) => {
          if (g === null || g === undefined) return "";
          const s = String(g).trim().toLowerCase();
          if (!s) return "";
          if (s === "male" || s === "m") return "Male";
          if (s === "female" || s === "f") return "Female";
          if (s === "other" || s === "o") return "Other";
          return s.charAt(0).toUpperCase() + s.slice(1);
        };
        const normalizeTitle = (t) => {
          if (t === null || t === undefined) return "";
          const s = String(t).trim().toLowerCase().replace(/\./g, '');
          if (!s) return "";
          if (s === 'mr' || s === 'mister') return 'Mr';
          if (s === 'ms') return 'Ms';
          if (s === 'mrs') return 'Mrs';
          if (s === 'miss') return 'Miss';
          if (s === 'dr' ) return 'Dr';
          if (s === 'prof' || s === 'professor') return 'Prof';
          if (s === 'master') return 'Master';
          return s.charAt(0).toUpperCase() + s.slice(1);
        };

        const proposerGenderRaw = data?.proposer?.proposer_gender;
        const travellerGenderRaw = Array.isArray(data?.travellers) && data.travellers[0]?.gender ? data.travellers[0].gender : "";
        const proposerGender = normalizeGender(proposerGenderRaw);
        const travellerGender = normalizeGender(travellerGenderRaw);
        const proposerTitleRaw = data?.proposer?.proposer_title;
        const travellerTitleRaw = Array.isArray(data?.travellers) && data.travellers[0]?.title ? data.travellers[0].title : "";
        const nomineeTitleRaw = Array.isArray(data?.nominees) && data.nominees[0]?.nominee_title ? data.nominees[0].nominee_title : "";
        const proposerTitle = normalizeTitle(proposerTitleRaw);
        const travellerTitle = normalizeTitle(travellerTitleRaw);
        const nomineeTitle = normalizeTitle(nomineeTitleRaw);

        console.log('fetchData: api proposerGender raw =', proposerGenderRaw, ', normalized =', proposerGender, ', api travellerGender raw =', travellerGenderRaw, ', normalized =', travellerGender);
        console.log('fetchData: api proposerTitle raw =', proposerTitleRaw, ', normalized =', proposerTitle, ', api travellerTitle raw =', travellerTitleRaw, ', normalized =', travellerTitle, ', api nomineeTitle raw =', nomineeTitleRaw, ', normalized =', nomineeTitle);

        // attempt to derive planId from response
        const planIdCandidate = rawData?.planDetails?.id || rawData?.planDetails?.plan_id || data?.documentDetails?.plan_id || rawData?.plan_id || rawData?.planDetails?.planId || rawData?.planId || rawData?.plan?.id || null;
        if (planIdCandidate) planIdRef.current = planIdCandidate;

        // Detect AMT plan by title/name containing 'AMT'
        const planTitleForDetect = (
          rawData?.title ||
          data?.documentDetails?.plan_name ||
          rawData?.planDetails?.name ||
          ""
        ).toString();
        const amtDetected = /\bAMT\b/i.test(planTitleForDetect) || /annual\s*multi\s*trip/i.test(planTitleForDetect);
        setIsAMT(amtDetected);
        console.log("AMT detected:", amtDetected, "from plan title:", planTitleForDetect);

        // Detect Domestic by geo scope name
        const geoScopeTitle = (rawData?.name || data?.documentDetails?.geo_scope || "").toString();
        const domesticDetected = geoScopeTitle.trim().toLowerCase() === 'domestic';
        setIsDomestic(domesticDetected);
        if (domesticDetected) {
          // Capture domestic-specific values for later payload augmentation
            const dd = data?.documentDetails || {};
            domesticRef.current = {
              plan_id: planIdCandidate || dd?.plan_id || rawData?.plan_id || null,
              to_city: dd?.to_city || null,
              to_state: dd?.to_state || null,
              from_city: dd?.from_city || null,
              company_id: rawData?.company_id || rawData?.client_company_id || dd?.company_id || null,
              from_state: dd?.from_state || null,
              to_country: Array.isArray(dd?.to_country) ? dd.to_country : (dd?.to_country ? [dd.to_country] : []),
              geo_country: Array.isArray(dd?.geo_country) ? dd.geo_country : (dd?.geo_country ? [dd.geo_country] : []),
              base_premium: dd?.base_premium,
              addons_premium: dd?.addons_premium,
              member_premium: dd?.member_premium,
              member_coverage: dd?.member_coverage,
              travel_end_date: dd?.travel_end_date || dd?.travel_endDate || dd?.travel_end || '',
              quotation_number: rawData?.quotation_number || dd?.quotation_number,
              same_as_proposer: true, // assumption (single traveller / proposer same) - adjust if backend sends a flag
              travel_start_date: dd?.travel_start_date || dd?.travel_startDate || dd?.travel_start || '',
              number_of_travel_days: dd?.number_of_travel_days || values.tnod || '',
            };
            console.log('Domestic detected. Captured domestic data for payload:', domesticRef.current);
        } else {
            domesticRef.current = null;
        }
  // A2A detection: plan title must exactly match 'Anywhere To Anywhere' (case-insensitive) after normalizing whitespace
        const toCountryIds = Array.isArray(data?.documentDetails?.to_country)
          ? data.documentDetails.to_country
          : data?.documentDetails?.to_country
          ? [data.documentDetails.to_country]
          : [];
        const fromCountryIds = Array.isArray(data?.documentDetails?.geo_country)
          ? data.documentDetails.geo_country
          : data?.documentDetails?.geo_country
          ? [data.documentDetails.geo_country]
          : [];
  const normalizedPlanTitle = planTitleForDetect.toLowerCase().replace(/\s+/g,' ').trim();
  const a2aDetected = !amtDetected && normalizedPlanTitle === "anywhere to anywhere";
  console.log('A2A detection check:', { rawPlanTitle: planTitleForDetect, normalizedPlanTitle, amtDetected, a2aDetected });
        setIsA2A(a2aDetected);

        setValues((prev) => ({
          ...prev,
          country: selectedCountries,
          proposerGender,
          travellerGender,
          proposerTitle,
          travellerTitle,
          nomineeTitle,
          planId: planIdCandidate || prev.planId || "",
        }));
  // NOTE: The following log previously used isA2A right after calling setIsA2A,
  // which can appear stale because state updates are async. We now log the
  // computed detection flag directly here. A separate useEffect below logs
  // the real state once React commits it.
  console.log('A2A immediate (computed, not yet committed):', a2aDetected);
  if (a2aDetected) { // map from/to country ids if provided for A2A
          const fromSelected = fromCountryIds
            .map(id => countryList.find(c => c.value === id))
            .filter(Boolean)
            .slice(0,1);
          const toSelected = toCountryIds
            .map(id => countryList.find(c => c.value === id))
            .filter(Boolean)
            .slice(0,1);
          setFromCountry(fromSelected);
          setToCountry(toSelected);
        }

        // Map other fields
        const getValue = (key) => {
          if (key === "assistanceScheme") return rawData?.client_company_alias || "";
          if (key === "documentType") return rawData?.title || "";
          if (key === "geoScope") return rawData?.name || "";
          if (key === "jsd") return data?.documentDetails?.travel_start_date || data?.travel_start_date || "";
          if (key === "jed") return data?.documentDetails?.travel_end_date || data?.travel_end_date || "";
          if (key === "tnod") return data?.documentDetails?.number_of_travel_days || data?.number_of_travel_days || "";
          if (key === "planChange") return rawData?.planDetails?.title || "";
          if (key === "cover") return data?.documentDetails?.member_coverage || "";
          if (key.startsWith("proposer")) {
            if (key === "proposerFname") return data?.proposer?.proposer_first_name || "";
            if (key === "proposerMname") return data?.proposer?.proposer_middle_name || "";
            if (key === "proposerLname") return data?.proposer?.proposer_last_name || "";
            if (key === "proposerDob") return data?.proposer?.proposer_dob || "";
            if (key === "proposerGender") return data?.proposer?.proposer_gender || "";
            if (key === "proposerTitle") return data?.proposer?.proposer_title || "";
            if (key === "proposerPassport") return data?.proposer?.proposer_passport_number || "";
            if (key === "proposerUniqueNumber") return data?.proposer?.proposer_unique_number || data?.proposer?.proposer_passport_number || "";
            if (key === "proposerEmail") return data?.proposer?.proposer_email || "";
            if (key === "proposerMobile") return data?.proposer?.proposer_mobile || "";
            if (key === "proposerPincode") return data?.proposer?.proposer_pin_code || "";
            if (key === "address") return data?.proposer?.proposer_address || "";
            if (key === "city") return data?.proposer?.city || "";
            if (key === "state") return data?.proposer?.state || "";
          }
          if (key.startsWith("traveller") && Array.isArray(data?.travellers)) {
            const t = data.travellers[0];
            if (!t) return "";
            if (key === "travellerFname") return t.firstName || "";
            if (key === "travellerMname") return t.middleName || "";
            if (key === "travellerLname") return t.lastName || "";
            if (key === "travellerDob") return t.traveller_dob || "";
            if (key === "travellerGender") return t.gender || "";
            if (key === "travellerTitle") return t.title || "";
            if (key === "travellerPassport") return t.traveller_passport || "";
            if (key === "travellerUniqueNumber") return t.traveller_unique_number || t.traveller_passport || "";
            if (key === "travellerCi") return t.critical_illness || "";
            if (key === "travellerPed") return t.pre_existing_disease || "";
          }
          if (key.startsWith("nominee") && Array.isArray(data?.nominees)) {
            const n = data.nominees[0];
            if (!n) return "";
            if (key === "nomineeFname") return n.nominee_firstName || "";
            if (key === "nomineeMname") return n.nominee_middleName || "";
            if (key === "nomineeLname") return n.nominee_lastName || "";
            if (key === "nomineeDob") return n.nominee_dob || "";
            if (key === "nomineeTitle") return n.nominee_title || "";
            if (key === "nomineeRelationship") return n.nominee_relation || "";
          }
          if (key === "countryOfResidence") return data?.documentDetails?.geo_country?.[0] === 118 ? "India" : "";
          return "";
        };

        setValues((prev) => {
          const updated = { ...prev };
          FIELDS.forEach(({ key }) => {
            if (key !== "country") {
              const val = getValue(key);
              // Override initial/default state with API-provided values.
              // Accept empty string as a valid value returned by API so we don't
              // fall back to hard-coded dummy defaults.
              if (val !== undefined && val !== null) updated[key] = val;
            }
          });
          // Always set gender and title fields from API response (use normalized values)
          updated.proposerGender = proposerGender || "";
          updated.travellerGender = travellerGender || "";
          updated.proposerTitle = proposerTitle || "";
          updated.travellerTitle = travellerTitle || "";
          updated.nomineeTitle = nomineeTitle || "";
          // If AMT detected, auto compute end + tnod when start date available
          if (amtDetected && updated.jsd) {
            const autoEnd = calcAmtEndDate(updated.jsd);
            updated.jed = autoEnd;
            updated.tnod = autoEnd ? 365 : updated.tnod;
          }
          // Map pre-existing disease related readonly fields if traveller has PED YES
          const traveller0 = Array.isArray(data?.travellers) ? data.travellers[0] : null;
          if (traveller0) {
            const pedFlag = (traveller0.pre_existing_disease || traveller0.travellerPed || "").toString().trim().toUpperCase();
            updated.travellerPed = pedFlag;
            if (pedFlag === "YES") {
              updated.ped_type = traveller0.ped_type || traveller0.pedType || traveller0.disease_type || "";
              updated.suffering_since = traveller0.suffering_since || traveller0.sufferingSince || traveller0.disease_since || "";
              updated.critical_illness = traveller0.critical_illness || traveller0.travellerCi || "";
              updated.under_medication = traveller0.under_medication || traveller0.medication || traveller0.on_medication || "";
            } else {
              // Ensure empty if not YES
              updated.ped_type = "";
              updated.suffering_since = "";
              updated.critical_illness = updated.critical_illness || "";
              updated.under_medication = "";
            }
          }
          return updated;
        });

        if (onQuoteData) {
          const dd = data?.documentDetails || {};
          const proposer = data?.proposer || {};
          onQuoteData({
            quotation_number: rawData?.quotation_number || dd?.quotation_number,
            member_premium: dd?.pricing_member_premium,
            total_premium: dd?.total_premium,
            base_premium: dd?.base_premium,
            addons_premium: dd?.addons_premium,
            proposer_title: proposer?.proposer_title,
            proposer_first_name: proposer?.proposer_first_name,
            proposer_last_name: proposer?.proposer_last_name,
            plan_name: dd?.plan_name,
          });
        }
      } catch (err) {
        console.error("Failed to fetch quotation or country list", err);
        // notify parent (stepper) so it can show an error page if desired
        if (typeof onLoadError === 'function') {
          try { onLoadError(err); } catch (e) { console.error('onLoadError handler failed', e); }
        }
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  // Load states when Domestic detected
  useEffect(() => {
    if (!isDomestic) return;
    const loadStates = async () => {
      try {
        const res = await fetchState();
        const list = res?.data?.result?.stateList || [];
        const opts = list.map(s => ({ value: s.state_id, label: s.name }));
        setStateOptions(opts);
        // Prefill from API domesticRef values if any
        if (domesticRef.current) {
          if (domesticRef.current.from_state) {
            const fs = opts.find(o => o.value === Number(domesticRef.current.from_state));
            if (fs) setFromStateSel(fs);
          }
          if (domesticRef.current.to_state) {
            const ts = opts.find(o => o.value === Number(domesticRef.current.to_state));
            if (ts) setToStateSel(ts);
          }
        }
      } catch (err) {
        console.warn('Failed to fetch states', err);
      }
    };
    loadStates();
  }, [isDomestic]);

  // When from state changes load its cities (preserve API-provided city if available)
  useEffect(() => {
    const loadCities = async () => {
      if (!fromStateSel) return;
      try {
        const { data } = await fetchCityList({ state_id: Number(fromStateSel.value) });
        const list = data?.result?.cityList || [];
        const opts = list.map(c => ({ value: c.city_id, label: c.name }));
        setFromCityOptions(opts);
        domesticRef.current = domesticRef.current || {};
        domesticRef.current.from_state = fromStateSel.value;
        // If we already have a from_city from API and it exists in new list, select it; else clear
        const existingCityId = domesticRef.current.from_city;
        if (existingCityId) {
          const found = opts.find(o => o.value === Number(existingCityId));
          if (found) {
            setFromCitySel(found);
          } else {
            setFromCitySel(null);
            domesticRef.current.from_city = null;
          }
        } else {
          setFromCitySel(null);
        }
      } catch (err) {
        console.warn('Failed to fetch from cities', err);
      }
    };
    loadCities();
  }, [fromStateSel]);

  // When to state changes load its cities (preserve API-provided city if available)
  useEffect(() => {
    const loadCities = async () => {
      if (!toStateSel) return;
      try {
        const { data } = await fetchCityList({ state_id: Number(toStateSel.value) });
        const list = data?.result?.cityList || [];
        const opts = list.map(c => ({ value: c.city_id, label: c.name }));
        setToCityOptions(opts);
        domesticRef.current = domesticRef.current || {};
        domesticRef.current.to_state = toStateSel.value;
        const existingCityId = domesticRef.current.to_city;
        if (existingCityId) {
          const found = opts.find(o => o.value === Number(existingCityId));
          if (found) {
            setToCitySel(found);
          } else {
            setToCitySel(null);
            domesticRef.current.to_city = null;
          }
        } else {
          setToCitySel(null);
        }
      } catch (err) {
        console.warn('Failed to fetch to cities', err);
      }
    };
    loadCities();
  }, [toStateSel]);

  // Track city selections into domesticRef
  useEffect(() => {
    if (fromCitySel) {
      domesticRef.current = domesticRef.current || {};
      domesticRef.current.from_city = fromCitySel.value;
    }
  }, [fromCitySel]);
  useEffect(() => {
    if (toCitySel) {
      domesticRef.current = domesticRef.current || {};
      domesticRef.current.to_city = toCitySel.value;
    }
  }, [toCitySel]);

  // Debug: log gender state when it changes
  useEffect(() => {
    console.log('state: proposerGender =', values.proposerGender, ', travellerGender =', values.travellerGender);
  }, [values.proposerGender, values.travellerGender]);

  // Log when isA2A actually updates (to avoid confusion with immediate logs after setState)
  useEffect(() => {
    console.log('isA2A state committed:', isA2A);
  }, [isA2A]);

  // A2A: ensure From and To are never the same; if duplicate occurs clear To
  useEffect(() => {
    if (isA2A && fromCountry[0] && toCountry[0] && fromCountry[0].value === toCountry[0].value) {
      setToCountry([]);
    }
  }, [isA2A, fromCountry, toCountry]);

  const [openSections, setOpenSections] = useState({
    "Travel Details": true,
  });

  const toggleAccordion = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // Handle field changes
  const handleChange = (key) => (e) => {
    if (key === "country") {
      // Multi-select dropdown
      const selected = Array.from(e.target.selectedOptions).map(opt => ({
        value: Number(opt.value),
        label: opt.label,
      }));
      setValues(s => ({ ...s, country: selected }));
    } else {
      const newVal = e.target.value;
      setValues((s) => ({ ...s, [key]: newVal }));
      // Clear any existing error for this field when user changes it
      setErrors((prev) => ({ ...prev, [key]: "" }));
      // Validation for nomineeRelationship (keep existing interaction flag)
      if (key === "nomineeRelationship") {
        setErrors((prev) => ({
          ...prev,
          nomineeRelationship: newVal ? "" : "Nominee relationship is required."
        }));
        // mark that user interacted so toasts can be shown
        interactedNomineeRef.current = true;
      }
    }
  };

  // Track user interaction for nomineeRelationship to avoid showing toast on initial load
  const interactedNomineeRef = useRef(false);

  // Show toast when nomineeRelationship validation error appears after user interaction
  useEffect(() => {
    if (interactedNomineeRef.current && errors.nomineeRelationship) {
      toast.error(errors.nomineeRelationship);
    }
  }, [errors.nomineeRelationship]);

  // Ordered required fields when Next is clicked - show first missing only
  const REQUIRED_SEQUENCE = [
    // Country skipped if AMT (auto) but still present logically for A2A (validated via from/to pair)
    ...(isAMT ? [] : ["country"]),
    "jsd",
    "jed",
    "tnod",
    "proposerDob",
    "proposerGender",
    "proposerTitle",
    "proposerFname",
    "proposerLname",
    "travellerDob",
    "travellerGender",
    "travellerTitle",
    "travellerFname",
    "travellerLname",
    "nomineeRelationship",
    ...(isDomestic ? ["from_state","to_state","from_city","to_city"] : []),
  ];

  const getFieldsBySection = (sectionName) => {
    const base = FIELDS
      .filter((field) => field.section === sectionName && visibleFields.includes(field.key))
      .filter((field) => !(isAMT && field.key === 'country'))
      .filter(field => {
        if (isDomestic) {
          if (field.key === 'proposerPassport' || field.key === 'travellerPassport') return false;
        } else {
          if (field.key === 'proposerUniqueNumber' || field.key === 'travellerUniqueNumber') return false;
        }
        return true;
      });

    // Dynamically append PED fields only inside Traveller Details when travellerPed flag is YES
    if (sectionName === 'Traveller Details' && values.travellerPed && values.travellerPed.toString().toUpperCase() === 'YES') {
      base.push(
        { key: 'ped_type', label: 'PED Type', readonly: true },
        { key: 'suffering_since', label: 'Suffering Since', readonly: true },
        { key: 'critical_illness', label: 'Critical Illness', readonly: true },
        { key: 'under_medication', label: 'Under Medication', readonly: true },
      );
    }
    return base;
  };

  const sections = [
    "Travel Details",
    "Proposer Details",
    "Traveller Details",
    "Nominee Details",
  ];

  // Get only non-freezed (editable) fields and their values
  const getNonFreezedData = () => {
    const nonFreezed = {};
    FIELDS.forEach(({ key }) => {
      if (!freezedFields.includes(key)) {
        if (key === "country") {
          nonFreezed[key] = values[key].map(c => c.value);
        } else {
          nonFreezed[key] = values[key];
        }
      }
    });
    return nonFreezed;
  };

  // Handle submit: create JSON of non-freezed fields and call submitDetails
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) {
      // Prevent spamming the API if an earlier request is still in flight
      console.debug('[ViewQuotation] handleSubmit blocked: already submitting');
      return false;
    }
    const now = Date.now();
    if (now - lastSubmitAt < 2000) { // 2s throttle window
      console.debug('[ViewQuotation] handleSubmit blocked: throttled');
      return false;
    }
    setLastSubmitAt(now);
    setSubmitting(true);
    console.debug('[ViewQuotation] handleSubmit invoked', new Date().toISOString());
    let payload = getNonFreezedData();
    if (isA2A) {
      // Replace generic geo_country list with explicit from/to for A2A
      payload.geo_country = fromCountry.map(c => c.value); // source
      payload.to_country = toCountry.map(c => c.value);    // destination
    }
    // Append Domestic specific required fields (do not remove existing keys)
    if (isDomestic && domesticRef.current) {
      payload = {
        ...payload,
        ...domesticRef.current,
        // Ensure date & days consistency if user edited them
        travel_start_date: values.jsd || domesticRef.current.travel_start_date,
        travel_end_date: values.jed || domesticRef.current.travel_end_date,
        number_of_travel_days: values.tnod || domesticRef.current.number_of_travel_days,
        proposer_unique_number: values.proposerUniqueNumber || undefined,
        traveller_unique_number: values.travellerUniqueNumber || undefined,
      };
      // Ensure geo_country reflects current selection (fallback to original domesticRef)
      payload.geo_country = (Array.isArray(values.country) && values.country.length > 0)
        ? values.country.map(c => c.value)
        : (domesticRef.current.geo_country || []);
      // Keep both planId and plan_id if planId exists so we don't break existing backend usage
      if (planIdRef.current) {
        payload.plan_id = planIdRef.current;
      }
    }
    // include planId if available
    if (planIdRef.current) payload.planId = planIdRef.current;
    else if (values.planId) payload.planId = values.planId;
    try {
      await updateQuatationById(id, payload);
      console.debug('[ViewQuotation] updateQuatationById success');
      return true;
    } catch (err) {
      console.error("Failed to update quotation", err);
      const msg = (err && err.response && err.response.data && (err.response.data.message || err.response.data.error)) || err.message || "Failed to update quotation";
      toast.error(msg);
      return false;
    } finally {
      setSubmitting(false);
    }
  };

  useEffect(() => {
    // Also validate tnod and nomineeRelationship
    if (setQuotationValid) {
      const valid = REQUIRED_EDITABLE.every(k =>
        !freezedFields.includes(k)
          ? (k === "country"
            ? (isAMT ? true : (isA2A ? (fromCountry.length === 1 && toCountry.length === 1) : (Array.isArray(values[k]) && values[k].length > 0)))
            : (values[k] ?? "").toString().trim() !== "")
          : true
      ) && (isAMT ? values.tnod === 365 : Number(values.tnod) > 0) && values.nomineeRelationship && (!isA2A || (fromCountry.length === 1 && toCountry.length === 1));
      setQuotationValid(valid);
    }
    // Set errors for initial load
    setErrors((prev) => ({
      ...prev,
      tnod: isAMT ? (values.tnod === 365 ? "" : "Travel days fixed at 365 for AMT") : (!values.tnod || Number(values.tnod) < 1 ? "Travel days must be at least 1." : ""),
      nomineeRelationship: !values.nomineeRelationship ? "Nominee relationship is required." : ""
    }));
  }, [values, isAMT, setQuotationValid]);

  const handleNextClick = async (e) => {
    if (e) e.preventDefault();
    // On Next, validate required fields in sequence and show only the first error
    interactedAnyRef.current = true;
    for (let i = 0; i < REQUIRED_SEQUENCE.length; i++) {
      const key = REQUIRED_SEQUENCE[i];
      const val = values[key];
      let missing = false;
      if (key === "country") {
        missing = isAMT ? false : (isA2A ? !(fromCountry.length === 1 && toCountry.length === 1) : (!Array.isArray(val) || val.length === 0));
      } else if (key === "tnod") {
        missing = isAMT ? val !== 365 : (!val || Number(val) < 1);
      } else if (isDomestic && (key === 'from_state' || key === 'to_state' || key === 'from_city' || key === 'to_city')) {
        missing = !domesticRef.current || !domesticRef.current[key];
      } else {
        missing = !val || String(val).toString().trim() === "";
      }
      if (missing) {
        // Mark interaction for nominee (if that field) and generally
        const isNominee = key === "nomineeRelationship";
        if (isNominee) interactedNomineeRef.current = true;
        // Derive label
        const label = key === 'tnod' ? 'Total No Of Travel Days' :
          key === 'jsd' ? 'Journey Start Date' :
          key === 'jed' ? 'Journey End Date' :
          key === 'proposerDob' ? 'Proposer DOB' :
          key === 'travellerDob' ? 'Traveller DOB' :
          key === 'proposerFname' ? 'Proposer First Name' :
          key === 'proposerLname' ? 'Proposer Last Name' :
          key === 'travellerFname' ? 'Traveller First Name' :
          key === 'travellerLname' ? 'Traveller Last Name' :
          key === 'proposerGender' ? 'Proposer Gender' :
          key === 'travellerGender' ? 'Traveller Gender' :
          key === 'proposerTitle' ? 'Proposer Title' :
          key === 'travellerTitle' ? 'Traveller Title' :
          key === 'country' ? (isA2A ? 'From & To Country' : 'Country') : key;

        setErrors((prev) => ({ ...prev, [key]: `${label} is required.` }));
        // Avoid duplicate toast: nomineeRelationship already triggers toast in useEffect watcher
        if (!isNominee) {
          toast.error(`${label} is required.`);
        }
        // focus the field if possible - simple UX improvement
        const el = document.getElementsByName(key)[0];
        if (el && typeof el.focus === 'function') el.focus();
        return;
      }
    }

    // If all validations pass, submit and proceed
    const ok = await handleSubmit(e || { preventDefault: () => {} });
    if (!ok) return; // do not proceed if submit failed
    // Force mark as valid so parent stepper doesn't show stale warning after successful save
  if (setQuotationValid) setQuotationValid(true);
  // Pass override flag so stepper doesn't re-block on stale quotationValid state
  if (onNext) onNext(true);
  };

  if (loading) {
    return (
      <div className="vq-loader-wrapper">
        <div className="vq-spinner" />
      </div>
    );
  }

  return (
    <div className="view-quotation-page">
      <div className="view-quotation-container">
        <form
          className="view-quotation-main-content"
          onSubmit={isStepper ? (e) => { e.preventDefault(); } : handleSubmit}
        >
          {!isStepper && (
            <img
              src="https://via.placeholder.com/680x200.png?text=Travel+Image"
              alt="travel"
              className="view-quotation-top-image"
            />
          )}

          {sections.map((sectionTitle) => (
            <Accordion
              key={sectionTitle}
              title={sectionTitle}
              isOpen={openSections[sectionTitle]}
              toggleAccordion={() => toggleAccordion(sectionTitle)}
            >
              <div className="view-quotation-fields-container">
                {getFieldsBySection(sectionTitle).map((field) => (
                  <div key={field.key} className="view-quotation-field-row">
                    <div
                      className={
                        freezedFields.includes(field.key)
                          ? "view-quotation-pill view-quotation-pill-active"
                          : "view-quotation-pill view-quotation-pill-light"
                      }
                    >
                      {field.label}
                    </div>
                    {field.key === "country" ? (
                      isA2A ? (
                        <div className="vq-a2a-country-wrapper" style={{display:'flex',gap:12,flexWrap:'wrap'}}>
                          <div style={{flex:'1 1 220px', minWidth:220}}>
                            <label className="vq-a2a-label">From</label>
                            <Select
                              isMulti={false}
                              // Exclude currently selected To country from From list
                              options={countryOptions.filter(o => !toCountry[0] || o.value !== toCountry[0].value)}
                              value={fromCountry[0] || null}
                              onChange={sel => {
                                const next = sel ? [sel] : [];
                                setFromCountry(next);
                                if (sel && toCountry[0] && toCountry[0].value === sel.value) {
                                  setToCountry([]); // clear conflicting To selection
                                }
                              }}
                              name="fromCountry"
                              placeholder="From Country"
                              className="view-quotation-country-select"
                              classNamePrefix="react-select"
                              {...selectPortalProps}
                            />
                          </div>
                          <div style={{flex:'1 1 220px', minWidth:220}}>
                            <label className="vq-a2a-label">To</label>
                            <Select
                              isMulti={false}
                              // Exclude currently selected From country from To list
                              options={countryOptions.filter(o => !fromCountry[0] || o.value !== fromCountry[0].value)}
                              value={toCountry[0] || null}
                              onChange={sel => {
                                const next = sel ? [sel] : [];
                                setToCountry(next);
                                if (sel && fromCountry[0] && fromCountry[0].value === sel.value) {
                                  setFromCountry([]); // clear conflicting From selection (alternate strategy)
                                }
                              }}
                              name="toCountry"
                              placeholder="To Country"
                              className="view-quotation-country-select"
                              classNamePrefix="react-select"
                              {...selectPortalProps}
                            />
                          </div>
                        </div>
                      ) : (
                        <Select
                          isMulti
                          options={countryOptions}
                          value={values.country}
                          onChange={selected => setValues(s => ({ ...s, country: selected || [] }))}
                          name="country"
                          placeholder="Select country(s)"
                          className="view-quotation-country-select"
                          classNamePrefix="react-select"
                          {...selectPortalProps}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              borderRadius: 999,
                              background: '#fff',
                              borderColor: state.isFocused ? '#3399ff' : '#ccc',
                              minHeight: 44,
                              boxShadow: state.isFocused ? '0 0 0 2px rgba(51,153,255,0.15)' : 'none',
                              fontWeight: 700,
                              fontSize: 14,
                            }),
                            valueContainer: (base) => ({
                              ...base,
                              padding: '0 14px',
                            }),
                            option: (base, state) => ({
                              ...base,
                              fontSize: 14,
                              fontWeight: 600,
                              padding: '10px 18px',
                              backgroundColor: state.isSelected
                                ? '#00239c'
                                : state.isFocused
                                ? '#e9eefc'
                                : '#fff',
                              color: state.isSelected ? '#fff' : state.isFocused ? '#0038d1' : '#122040',
                            }),
                            menu: (base) => ({
                              ...base,
                              borderRadius: 16,
                              boxShadow: '0 8px 30px rgba(2, 19, 70, 0.08)',
                              zIndex: 10,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              color: '#0038d1',
                            }),
                            clearIndicator: (base) => ({
                              ...base,
                              color: '#0038d1',
                            }),
                            indicatorSeparator: () => ({ display: 'none' }),
                          }}
                        />
                      )
                    ) : field.key === "nomineeRelationship" ? (
                      <>
                        <select
                          value={values.nomineeRelationship || ""}
                          onChange={handleChange("nomineeRelationship")}
                          className="view-quotation-input view-quotation-input-white"
                          name="nomineeRelationship"
                        >
                          <option value="">Select</option>
                          <option value="spouse">Spouse</option>
                          <option value="Son">Son</option>
                          <option value="Daughter">Daughter</option>
                          <option value="Mother">Mother</option>
                          <option value="Father">Father</option>
                          <option value="Brother">Brother</option>
                          <option value="Sister">Sister</option>
                          <option value="Grand_Father">Grand Father</option>
                          <option value="Grand_Mother">Grand Mother</option>
                          <option value="Grandson">Grand Son</option>
                          <option value="Grand_Daughter">Grand Daughter</option>
                          <option value="Guardian">Guardian</option>
                          <option value="Legal_Heir">Legal Heir</option>
                        </select>
                        {errors.nomineeRelationship && (
                          <div className="view-quotation-error-message">{errors.nomineeRelationship}</div>
                        )}
                      </>
                    ) : field.key === "jsd" ? (
                      <input
                        type="date"
                        value={values.jsd ?? ""}
                        onChange={handleJsdChange}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        readOnly={freezedFields.includes(field.key)}
                        disabled={freezedFields.includes(field.key)}
                        name={field.key}
                      />
                    ) : field.key === "jed" ? (
                      <input
                        type="date"
                        value={values.jed ?? ""}
                        onChange={handleJedChange}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        readOnly={freezedFields.includes(field.key)}
                        disabled={freezedFields.includes(field.key)}
                        name={field.key}
                      />
                    ) : field.key === "tnod" ? (
                      <>
                        <input
                          type="number"
                          min={1}
                          value={values.tnod ?? ""}
                          onChange={handleTnodChange}
                          className={
                            freezedFields.includes(field.key)
                              ? "view-quotation-input view-quotation-input-blue"
                              : "view-quotation-input view-quotation-input-white"
                          }
                          readOnly={freezedFields.includes(field.key)}
                          disabled={freezedFields.includes(field.key)}
                          name={field.key}
                        />
                        {errors.tnod && (
                          <div className="view-quotation-error-message">Please enter a valid number of travel days (minimum 1).</div>
                        )}
                      </>
                    ) : field.key === "proposerGender" ? (
                      <select
                        value={values.proposerGender || ""}
                        onChange={handleChange("proposerGender")}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        name="proposerGender"
                        disabled={freezedFields.includes(field.key)}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    ) : field.key === "travellerGender" ? (
                      <select
                        value={values.travellerGender || ""}
                        onChange={handleChange("travellerGender")}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        name="travellerGender"
                        disabled={freezedFields.includes(field.key)}
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </select>
                    ) : field.key === "proposerTitle" ? (
                      <select
                        value={values.proposerTitle || ""}
                        onChange={handleChange("proposerTitle")}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        name="proposerTitle"
                        disabled={freezedFields.includes(field.key)}
                      >
                        <option value="">Select Title</option>
                        <option value="Mr">Mr</option>
                        <option value="Ms">Ms</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Miss">Miss</option>
                        <option value="Dr">Dr</option>
                        <option value="Prof">Prof</option>
                        <option value="Master">Master</option>
                      </select>
                    ) : field.key === "travellerTitle" ? (
                      <select
                        value={values.travellerTitle || ""}
                        onChange={handleChange("travellerTitle")}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        name="travellerTitle"
                        disabled={freezedFields.includes(field.key)}
                      >
                        <option value="">Select Title</option>
                        <option value="Mr">Mr</option>
                        <option value="Ms">Ms</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Miss">Miss</option>
                        <option value="Dr">Dr</option>
                        <option value="Prof">Prof</option>
                        <option value="Master">Master</option>
                      </select>
                    ) : field.key === "nomineeTitle" ? (
                      <select
                        value={values.nomineeTitle || ""}
                        onChange={handleChange("nomineeTitle")}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        name="nomineeTitle"
                        disabled={freezedFields.includes(field.key)}
                      >
                        <option value="">Select Title</option>
                        <option value="Mr">Mr</option>
                        <option value="Ms">Ms</option>
                        <option value="Mrs">Mrs</option>
                        <option value="Miss">Miss</option>
                        <option value="Dr">Dr</option>
                        <option value="Prof">Prof</option>
                        <option value="Master">Master</option>
                      </select>
                    ) : dateFields.includes(field.key) ? (
                      <input
                        type="date"
                        value={values[field.key] ?? ""}
                        onChange={handleChange(field.key)}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        readOnly={freezedFields.includes(field.key)}
                        disabled={freezedFields.includes(field.key)}
                        name={field.key}
                      />
                    ) : (
                      <input
                        value={values[field.key] ?? ""}
                        onChange={handleChange(field.key)}
                        placeholder={field.label}
                        className={
                          freezedFields.includes(field.key)
                            ? "view-quotation-input view-quotation-input-blue"
                            : "view-quotation-input view-quotation-input-white"
                        }
                        readOnly={freezedFields.includes(field.key)}
                        name={field.key}
                      />
                    )}
                    {/* Generic inline error for other fields (tnod and nomineeRelationship already render their errors above) */}
                    {errors[field.key] && !["tnod", "nomineeRelationship"].includes(field.key) && (
                      <div className="view-quotation-error-message">{errors[field.key]}</div>
                    )}
                  </div>
                ))}
                {sectionTitle === 'Travel Details' && isDomestic && (
                  <div style={{display:'flex',flexWrap:'wrap',gap:16,marginTop:8,width:'100%'}}>
                    <div className="view-quotation-field-row" style={{flex:'1 1 230px',minWidth:220}}>
                      <div className="view-quotation-pill view-quotation-pill-light">From State</div>
                      <Select
                        placeholder="Select From State"
                        options={stateOptions}
                        value={fromStateSel}
                        onChange={sel => setFromStateSel(sel)}
                        classNamePrefix="react-select"
                        {...selectPortalProps}
                      />
                    </div>
                    <div className="view-quotation-field-row" style={{flex:'1 1 230px',minWidth:220}}>
                      <div className="view-quotation-pill view-quotation-pill-light">From City</div>
                      <Select
                        placeholder={fromStateSel ? 'Select From City' : 'Select state first'}
                        isDisabled={!fromStateSel}
                        options={fromCityOptions}
                        value={fromCitySel}
                        onChange={sel => setFromCitySel(sel)}
                        classNamePrefix="react-select"
                        {...selectPortalProps}
                      />
                    </div>
                    <div className="view-quotation-field-row" style={{flex:'1 1 230px',minWidth:220}}>
                      <div className="view-quotation-pill view-quotation-pill-light">To State</div>
                      <Select
                        placeholder="Select To State"
                        options={stateOptions}
                        value={toStateSel}
                        onChange={sel => setToStateSel(sel)}
                        classNamePrefix="react-select"
                        {...selectPortalProps}
                      />
                    </div>
                    <div className="view-quotation-field-row" style={{flex:'1 1 230px',minWidth:220}}>
                      <div className="view-quotation-pill view-quotation-pill-light">To City</div>
                      <Select
                        placeholder={toStateSel ? 'Select To City' : 'Select state first'}
                        isDisabled={!toStateSel}
                        options={toCityOptions}
                        value={toCitySel}
                        onChange={sel => setToCitySel(sel)}
                        classNamePrefix="react-select"
                        {...selectPortalProps}
                      />
                    </div>
                  </div>
                )}
                {/* PED fields now injected only within Traveller Details via getFieldsBySection */}
        </div>
            </Accordion>
          ))}

          <div className="view-quotation-submit-container" style={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}>
            {!isStepper && (
              <button className="view-quotation-submit-button" type="submit">
                Submit Details
              </button>
            )}
            {isStepper && (
              <button
                className="view-quotation-submit-button"
                type="button"
                onClick={handleNextClick}
                disabled={Boolean(errors.tnod) || submitting}
              >
                Next
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default ViewQuotation;